import React from 'react';
import { Box, Button, Chip, IconButton, InputAdornment, OutlinedInput, Paper, Stack, SvgIcon, Typography } from '@mui/material';
import MagnifyingGlassIcon from '@heroicons/react/24/outline/MagnifyingGlassIcon';
import ArrowDownTrayIcon from '@heroicons/react/24/outline/ArrowDownTrayIcon';
import CalendarIcon from '@heroicons/react/24/outline/CalendarIcon';
import CheckCircleIcon from '@heroicons/react/24/outline/CheckCircleIcon';
import { CustomPopOver } from '../custom-popover';
import { MobileActionSheet } from './mobile-action-sheet';
import { MOBILE_BOTTOM_NAV_HEIGHT } from '../../dashboard/mobile/constants';

function formatRangeDate(value) {
  return value?.format ? value.format('D MMM YYYY') : '';
}

export function MobileSearchBar({
  popoverItems,
  handleSearch,
  exportExcel,
  getDataForExportExcel,
  selectedItems,
  confirmSelectedOrderStatus,
  statusOfOrder = [],
  from,
  to,
  handleBodyChange,
}) {
  const [dateSheetOpen, setDateSheetOpen] = React.useState(false);
  const [statusSheetOpen, setStatusSheetOpen] = React.useState(false);
  const selectedCount = selectedItems?.selected?.length || 0;
  const showBulkBar = Boolean(confirmSelectedOrderStatus) && selectedCount > 0;

  return (
    <>
      <CustomPopOver
        open={dateSheetOpen}
        onClose={() => setDateSheetOpen(false)}
        popoverItems={popoverItems}
        from={from}
        to={to}
        handleBodyChange={handleBodyChange}
      />
      {confirmSelectedOrderStatus && (
        <MobileActionSheet
          open={statusSheetOpen}
          onClose={() => setStatusSheetOpen(false)}
          title={`Update ${selectedCount} selected`}
          actions={statusOfOrder.map((item) => ({
            id: item.value,
            label: item.label,
            icon: (
              <SvgIcon fontSize="small" sx={{ color: 'primary.main' }}>
                <CheckCircleIcon />
              </SvgIcon>
            ),
            onClick: () => confirmSelectedOrderStatus(item.value),
          }))}
        />
      )}

      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 2,
          mx: -1.5,
          px: 1.5,
          py: 1,
          bgcolor: 'background.default',
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <OutlinedInput
            defaultValue=""
            fullWidth
            placeholder="Search"
            type="search"
            startAdornment={(
              <InputAdornment position="start">
                <SvgIcon color="action" fontSize="small">
                  <MagnifyingGlassIcon />
                </SvgIcon>
              </InputAdornment>
            )}
            sx={{ borderRadius: 999, bgcolor: 'background.paper', height: 44 }}
            onChange={(event) => handleSearch && handleSearch(event)}
          />
          {popoverItems && getDataForExportExcel && (
            <IconButton
              aria-label="Download excel"
              disabled={exportExcel}
              onClick={() => getDataForExportExcel()}
              sx={{ border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', width: 44, height: 44 }}
            >
              <SvgIcon fontSize="small">
                <ArrowDownTrayIcon />
              </SvgIcon>
            </IconButton>
          )}
        </Stack>
        {popoverItems && from && (
          <Chip
            icon={
              <SvgIcon fontSize="small">
                <CalendarIcon />
              </SvgIcon>
            }
            label={`${formatRangeDate(from)} – ${formatRangeDate(to)}`}
            onClick={() => setDateSheetOpen(true)}
            variant="outlined"
            sx={{ mt: 1, bgcolor: 'background.paper', fontWeight: 500 }}
          />
        )}
      </Box>

      {showBulkBar && (
        <Paper
          elevation={8}
          sx={{
            position: 'fixed',
            left: 12,
            right: 84,
            bottom: `calc(${MOBILE_BOTTOM_NAV_HEIGHT + 16}px + env(safe-area-inset-bottom))`,
            zIndex: (theme) => theme.zIndex.speedDial,
            borderRadius: 999,
            display: 'flex',
            alignItems: 'center',
            pl: 2,
            pr: 0.75,
            py: 0.75,
            bgcolor: 'text.primary',
            color: 'background.paper',
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 700, mr: 'auto' }}>
            {`${selectedCount} selected`}
          </Typography>
          <Button
            size="small"
            variant="contained"
            onClick={() => setStatusSheetOpen(true)}
            sx={{ borderRadius: 999, px: 2 }}
          >
            Update status
          </Button>
        </Paper>
      )}
    </>
  );
}
